import CompanyInformationForm from "@app/components/company-information-form.tsx";
import SystemConfigurationForm from "@app/components/forms/admin/system-configuration-form.tsx";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

interface SearchParams {
    tab?: string;
}

export const Route = createFileRoute("/_authenticated/_admin/admin/other/system-info")({
    component: Component,
    validateSearch: (search: Record<string, unknown>): SearchParams => {
        return {
            tab: search.tab as string | undefined,
        };
    },
});

function Component() {
    const search = Route.useSearch();
    const [activeTab, setActiveTab] = useState(search.tab ?? "system config");

    const navigate = useNavigate();

    const handleChangeTab = (tab: string) => {
        setActiveTab(tab);
        void navigate({ to: ".", search: { ...search, tab: tab } });
    };

    return (
        <TabContext value={activeTab}>
            <TabList onChange={(_e, value) => handleChangeTab(value)}>
                <Tab value={"system config"} label={"System Configuration"} />
                <Tab value={"company info"} label={"Company Information"} />
            </TabList>
            <TabPanel value={"system config"}>
                <SystemConfigurationForm />
            </TabPanel>
            <TabPanel value={"company info"}>
                <CompanyInformationForm />
            </TabPanel>
        </TabContext>
    );
}
